export default __webpack_public_path__ + "static/media/featSportBgMb.7cd752ee.png";